import styled from "styled-components";

export const Container = styled.form`
width: 100%;
padding: 2rem;
display: flex;
flex-direction: column;
gap: 2rem;


.categories-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width:510px) {
        flex-wrap: wrap;
        gap: 20px;
    }

    h1{
        font-weight: 600;
    }

    .add-ingredient-button-container{
        display: flex;
        gap: 1rem;
          @media (max-width:510px) {
        flex-wrap: wrap;
      justify-content: center;
    }
    }
}

td{
    width: 18rem !important;
}

th{
    width: 18rem !important;
}

.th{
    width: 10rem !important;
}
`
